import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';
import { RulesetResult } from '../../pages/dashboard/loan_detail/flows/NewWelcomeFlow/business/rules';
import OffTakerUtilityBillRuleset from '../../pages/dashboard/loan_detail/flows/NewWelcomeFlow/business/ruleset/OffTakerUtilityBillRuleset';
import MultipleFilesValidationSchema from '../MultipleFilesValidationSchema';

const { offTakerUtilityBill } = loanFormModel.formField.solarSystemDocuments;

export class OffTakerUtilityBillValidation implements ValidationSchema {
  public name = offTakerUtilityBill.name;
  public label = '';

  public type = 'array';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public ruleset = OffTakerUtilityBillRuleset;

  public when(schema: any, ...args: any[]) {
    const result: RulesetResult = args.pop();
    const required = !!(result & RulesetResult.REQUIRED);

    return MultipleFilesValidationSchema(offTakerUtilityBill.name, required);
  }
}
export default new Validation(new OffTakerUtilityBillValidation());
